import { PathBase } from "@constellation-academy/epic-ui";

export class OfferCataloguePath extends PathBase {
	static readonly pathKey = "offerCatalogue";
	static readonly pathName = "offer-catalogue";
}
